export default __webpack_public_path__ + "media/images/mute-7b6ddbacc82afb68ebba3f0384204e0f.svg";